import {
  MdPeople,
  MdSchool,
  MdGroups,
  MdPhone,
  MdUpload,
} from "react-icons/md";
import {
  FaShareAlt,
  FaGamepad,
  FaLightbulb,
  FaBullhorn,
  FaQuestionCircle,
  FaUsers,
  FaEdit,
} from "react-icons/fa";
import { IoNavigate, IoTime } from "react-icons/io5";

// Custom icons
import CompanyMeetingIcon from "../components/Icons/CompanyMeetingIcon";
import TrainingIcon from "../components/Icons/TrainingIcon";
import TeamMeetingIcon from "../components/Icons/TeamMeetingIcon";
import ClientCallIcon from "../components/Icons/ClientCallIcon";
import FaithGatheringIcon from "../components/Icons/FaithGatheringIcon";
import UploadPresentationIcon from "../components/Icons/UploadPresentationIcon";
import ShareUpdatesIcon from "../components/Icons/ShareUpdatesIcon";
import DecisionIcon from "../components/Icons/DecisionIcon";
import PlanStepsIcon from "../components/Icons/PlanStepsIcon";
import FeedbackIcon from "../components/Icons/FeedbackIcon";
import QuestionIcon from "../components/Icons/QuestionIcon";
import BrainstormIcon from "../components/Icons/BrainstormIcon";

/**
 * Icon mapping for blueprint properties
 * Maps string icon names from smartAgendasContent.json to React icon components
 */

// Meeting Type Icons
export const meetingTypeIcons = {
  MdPeople,
  MdSchool,
  MdGroups,
  MdPhone,
  MdUpload,
  FaQuestionCircle,
  // Custom icons
  CompanyMeetingIcon,
  TrainingIcon,
  TeamMeetingIcon,
  ClientCallIcon,
  FaithGatheringIcon,
  UploadPresentationIcon,
};

// Goal Icons
export const goalIcons = {
  FaShareAlt,
  FaGamepad,
  FaLightbulb,
  FaBullhorn,
  FaQuestionCircle,
  MdSchool,
  // Custom icons
  ShareUpdatesIcon,
  DecisionIcon,
  PlanStepsIcon,
  FeedbackIcon,
  QuestionIcon,
  BrainstormIcon,
};

// Property Icons (for audience, style, focus, duration)
export const propertyIcons = {
  audience: FaUsers,
  style: FaEdit,
  focusArea: IoNavigate,
  duration: IoTime,
};

/**
 * Get icon component for meeting type
 */
export const getMeetingTypeIcon = (iconName) => {
  return meetingTypeIcons[iconName] || FaQuestionCircle;
};

/**
 * Get icon component for goal
 */
export const getGoalIcon = (iconName) => {
  return goalIcons[iconName] || FaQuestionCircle;
};

/**
 * Get icon component for blueprint property
 */
export const getPropertyIcon = (propertyType) => {
  return propertyIcons[propertyType] || FaQuestionCircle;
};

/**
 * Format duration from minutes to readable string
 */
export const formatDuration = (minutes) => {
  if (!minutes) return "Not specified";

  if (minutes < 60) {
    return `${minutes} min`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingMinutes === 0) {
    return `${hours} hr${hours > 1 ? "s" : ""}`;
  }

  return `${hours}h ${remainingMinutes}m`;
};

export default {
  getMeetingTypeIcon,
  getGoalIcon,
  getPropertyIcon,
  formatDuration,
};
